// extracted by mini-css-extract-plugin
export default {"filter":"TablesSelectFilter_filter__4XV1Y","disabled":"TablesSelectFilter_disabled__SJbfo"};